import React from 'react';
import { useSelector } from 'react-redux';
import VideoPreview from '../../../../ui/videoPreview/VideoPreview';
import ItemBlock from '../../itemBlock/ItemBlock';
import classes from './FinalHighlightsBlock.module.css';

const FinalHighlightsBlock = ({ title, text, video, img }) => {

    const { texts } = useSelector(state => state.translate);

    return (
        <ItemBlock title={title ? (texts[title] || title) : null}
            icon={<img src={img.src} alt={video.alt || ''} className={classes.imgIcon}/>}

            className={classes.finalHighlightsItem}>
            <div className={classes.content}>
                <div className={classes.rightSide}>
                    <img src={img.src} alt={video.alt || ''} className={classes.img} />
                    {text && <p className={classes.text}>{texts[text] || text}</p>}
                </div>
                {video &&
                    <VideoPreview url={video.url} alt={video.alt || ""} showPlayIcon={true} />
                }

            </div>
        </ItemBlock>
    );
};

export default FinalHighlightsBlock;

